const convertQuerySearchIntoObject = (query: string) =>
  [...new URLSearchParams(query).entries()].reduce((acc, [key, value]: [string, string]) => {
    acc[key] = value;
    return acc;
  }, {} as Record<string, string>);

export default convertQuerySearchIntoObject;
